import Vue from "vue";

import Swatches from "vue-swatches";
import Navbar from "@/components/navbar";
import Dropdown from "@/components/dropdown";
import DrawerNavigation from "@/components/drawerNavigation";
import Pagination from "@/components/Pagination";
import InputFile from "@/components/InputFile.vue";
import DisabledItemButton from "@/components/DisabledItemButton.vue";
import HiddenItemButton from "@/components/HiddenItemButton.vue";

Vue.component("nav-bar", Navbar);
Vue.component("dropdown", Dropdown);
Vue.component("drawer-navigation", DrawerNavigation);
Vue.component("swatches", Swatches);
Vue.component("pagination", Pagination);
Vue.component("input-file", InputFile);
Vue.component("disabled-item-button", DisabledItemButton);
Vue.component("hidden-item-button", HiddenItemButton);
